import { ITemplateTextComponent } from "entities/template";
import React from "react";
import { ComponentTooltip, IComponentTooltipSettings } from "../component_tooltip/component_tooltip";
import { transformMarkdown } from "../../../../lib/utils/markdown";
import styles from "./document_form_text.module.scss";

interface IDocumentFormTextProps {
    component: ITemplateTextComponent;
    label?: string;
    tooltip: IComponentTooltipSettings;
}

export const DocumentFormText: React.FC<IDocumentFormTextProps> = React.memo(({
                                                                                    component,
                                                                                    label,
                                                                                    tooltip
                                                                                }) => {
    return label ?
        <div className={styles.container}>
            <div className={styles.input}>{ transformMarkdown( label ) }</div>
            <ComponentTooltip tooltip={tooltip} id={component.id.toString()} className={styles.tooltip}/>
        </div>
    : null;
});
